
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ship-to-storage",
      function () {
        return require("private-next-pages/ship-to-storage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ship-to-storage"])
      });
    }
  